<template>
  <div class="request-mark-wrap">
    <MultipleFilter
      ref="multipleFilter"
      :options="filterOptions"
      @chacked="mutipleChacked"
      @closeTag="handlecloseTag"
    ></MultipleFilter>
    <SimpleFilter
      :keywords="keywords"
      @search="handleSearch"
      @issueTime="handleIssue"
      @viewCount="handleView"
      @handleDefault="handleDefault"
    ></SimpleFilter>
    <div class="request-content-wrap">
      <a-row :gutter="[20, 0]">
        <a-col :span="18">
          <div class="spin-wrap" v-if="loading">
            <a-spin :spinning="loading" />
          </div>
          <Empty v-if="isEmpty" class="empty-wrap"></Empty>
          <div v-if="!isEmpty && !loading" class="card-wrap">
            <RequestCard
              v-for="(item, index) in requestInfos"
              :key="index"
              :instance="item"
            ></RequestCard>
          </div>
          <Pagination :total="total" @pageChange="handleChange"></Pagination>
        </a-col>
        <a-col :span="6">
        <SideWrap iconName="iconHotTag.png" type="img" title="热门标签">
            <div class="hot-tags-wrap">
              <span
                v-for="item in hotTags"
                :key="item.name"
                :class="{active: item.name === hotTagSelected}"
                @click="handleHottags(item.name)"
                >{{ item.name }}</span
              >
            </div>
          </SideWrap>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import SimpleFilter from '@/components/common/SimpleFilter'
import MultipleFilter from '@/components/MultipleFilter'
import RequestCard from './components/requestCard.vue'
import SideWrap from '../../components/SideWrap.vue'
import Empty from '@/components/common/Empty/index'
import { filterOptions } from './config'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { getDemandsInfo, getDemandHottagInfo } from '@/api/tradingInfos.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      keywords: '', // 检索关键词
      filterOptions,
      hotTags: [], // 热门标签
      requestInfos: [],
      params: {
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      body: {},
      loading: false,
      isEmpty: false,
      // 热门标签
      hotTagSelected: ''
    }
  },
  components: {
    Pagination,
    SimpleFilter,
    MultipleFilter,
    RequestCard,
    SideWrap,
    Empty
  },
  created() {
    this.initHottags()
  },
  computed: {
    ...mapGetters('headerSearch', [
      'headSearchValueDemand'
    ])
  },
  watch: {
    // '$route'() {
    //   this.initParams()
    //   this.initDefaultValue()
    // }
    headSearchValueDemand: {
      handler() {
        this.initParams()
        this.initDefaultValue()
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('headerSearch', [
      'updateTabValue'
    ]),
    // 初始化关键词、请求体
    initParams() {
      this.keywords = this.headSearchValueDemand
      this.body = {
        name: this.headSearchValueDemand
      }
    },
    // 初始化方法
    async initDefaultValue() {
      try {
        this.loading = true
        const body = {...this.body}
        if(this.hotTagSelected) {
          body.tag = this.hotTagSelected
        }
        const { data } = await getDemandsInfo(this.params, body)
        const rows = this.handlerDateFormat(data.rows)
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.isEmpty = rows.length === 0
        this.total = data.total
        this.requestInfos = rows
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    // 初始化热门标签
    async initHottags() {
      const { data } = await getDemandHottagInfo()
      const datas = data.map((item) => {
        return { name: item }
      })
      this.hotTags = datas
    },
    mutipleChacked(result) {
      const datas = {}
      Object.keys(result).forEach((key) => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value
        } = data
        datas[prop] = value
      })
      // console.log(datas)
      this.body = datas
      this.initDefaultValue()
    },
    // 多选tag处理
    handlecloseTag(result) {
      const datas = {}
      Object.keys(result).forEach((key) => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value
        } = data
        datas[prop] = value
      })
      // console.log(datas)
      this.body = datas
      this.initDefaultValue()
    },
    handleSearch(e) {
      const params = { name: e }
      this.params = { ...this.params }
      this.body = params
      this.updateTabValue({ key: 'demand', value: e })
      // this.initDefaultValue()
    },
    // 切换页面
    handleChange(e) {
      // console.log(e)
      this.params.pageNum = e
      this.initDefaultValue()
    },
    // 筛选恢复默认
    handleDefault() {
      delete this.body.params
      this.initDefaultValue()
    },
    // 发布时间筛选
    handleIssue(e) {
      // console.log(e)
      this.body = { params: { sort: e, sortType: '0' } }
      this.initDefaultValue()
    },
    // 浏览量筛选
    handleView(e) {
      this.body = { params: { sort: e, sortType: '1' } }
      this.initDefaultValue()
    },
    // 热门标签筛选
    handleHottags(name) {
      // let params = {}
      if(name === this.hotTagSelected) {  // 反选
        this.hotTagSelected = ''
        // params = {}
      } else {
        // params = { tag: name }
        this.params = { ...this.params }
        this.hotTagSelected = name
      }
      // this.body = params
      this.$refs.multipleFilter.initSelected()
      this.initDefaultValue()
    }
  },
  destroyed() {
    // 重置vuex中的tab值
    this.updateTabValue({ key: 'demand', value: ''})
  }
}
</script>
